import Routes from './routes/Routes';
import 'style/global.scss'
import { useNavigate } from 'react-router-dom'
import { useDispatch } from 'react-redux';
import { add_user_data, change_login, reset_state, full_page_loader, set_dashboard_loaded } from 'redux/actions/AppActions';
import { constants } from 'redux/constants/redux-constants';
import jwtDecode from 'jwt-decode';
import { onAuthStateChanged, signOut } from 'firebase/auth';
import { useEffect, useState } from 'react';
import { auth } from 'firebase-setup';
import { GET_PERSON_FROM_UID } from 'adapters/auth.service';
import { set_current_user_setting, set_person_details, set_related_persons_details } from 'redux/actions/AuthActions';
import _ from 'lodash'
import UnauthorizedAccess from 'components/dialogs/UnauthorizedAccess';
import FallBackLoader from 'components/loader/FallbackLoader';
import { GET_RELATED_PERSONS, GET_USER_SETTINGS, SAVE_USER_SETTINGS } from 'adapters/ehr.service';
import dayjs from 'dayjs';

const App = () => {

  const reduxDispatch = useDispatch()
  const navigate = useNavigate()

  const [firebaseUser, setFirebaseUser] = useState(null);
  const [isFirebaseLoaded, setIsFirebaseLoaded] = useState(false);
  const [currentLocation, setCurrentLocation] = useState(null);
  const [isUserDataLoaded, setIsUserDataLoaded] = useState(false);
  const [open, setOpen] = useState(false);

  // if (localStorage?.getItem('jwt')) {
  //   const auth = localStorage?.getItem('jwt')
  //   const jwtPayLoad = jwtDecode(auth)
  //   const currentTime = Math?.floor(Date?.now() / 1000);

  //   if (jwtPayLoad?.exp < currentTime) {
  //     reduxDispatch(change_login(constants?.USER_LOGOUT))
  //     reduxDispatch(reset_state())
  //   }
  // }

  useEffect(() => {
    setCurrentLocation(window.location?.pathname);
  }, [window.location]);

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, user => {
      if (user) {
        let roles = user?.reloadUserInfo?.customAttributes ? JSON.parse(user?.reloadUserInfo?.customAttributes) : { enlivRoles: [] }
        if (navigator.onLine && !roles?.enlivRoles?.includes('portal_user')) {
          setOpen(true);
          signOut(auth)
            ?.then(() => {
              localStorage?.clear();
              setFirebaseUser(null);
              setIsFirebaseLoaded(true);
            })
            .catch(e => {
              console.log(`some issue in firebase signout`, e);
            });
          reduxDispatch(full_page_loader(false));
          return false;
        }
        setFirebaseUser(user);
        user
          ?.getIdToken()
          ?.then(token => {
            localStorage?.setItem('jwtToken', token)
            const jwtPayLoad = jwtDecode(token)
            reduxDispatch(add_user_data({ resource: jwtPayLoad, userId: jwtPayLoad?.user_id }))
            reduxDispatch(change_login(constants?.USER_CHECK_LOGIN));
            setIsFirebaseLoaded(true);
          })
          .catch(error => {
            setFirebaseUser(null);
            setIsFirebaseLoaded(true);
          });
      } else {
        setFirebaseUser(null);
        setIsFirebaseLoaded(true);
      }
    });

    return () => {
      unsubscribe()
    };
  }, []);

  useEffect(() => {
    refreshUserData(firebaseUser, isFirebaseLoaded);
  }, [firebaseUser, isFirebaseLoaded]);

  const createUserSetting = async userId => {
    let setting = {
      theme: 'light',
      language: 'en',
      isIntroDone: false,
    };
    let payload = {
      resourceType: 'Basic',
      code: {
        coding: [
          {
            system: 'http://enliv.com/code/basic-resource-type',
            code: 'user.preference.ui',
          },
        ],
      },
      subject: {
        reference: `Person/${userId}`,
      },
      created: dayjs().format('YYYY-MM-DD'),
      extension: [
        {
          url: 'http://enliv.com/settings/data',
          valueString: JSON.stringify(setting),
        },
      ],
    };

    const response = await SAVE_USER_SETTINGS(`POST`, payload);
    return response;
  };

  const getLoggedInPersonData = async uid => {
    setIsUserDataLoaded(false);
    try {
      let response = await GET_PERSON_FROM_UID(uid)
      const PersonID = response?.resource?.id;
      if (PersonID) {
        reduxDispatch(set_person_details(response?.resource));
        let resource= await GET_RELATED_PERSONS(response?.resource?.link || [])
        reduxDispatch(set_related_persons_details(resource))
        let currentUserSetting = await GET_USER_SETTINGS(PersonID);
        if (currentUserSetting?.data?.total){
          const rawData = { ...currentUserSetting?.data?.entry?.[0]?.resource };
          const displaySetting = rawData?.extension?.find(
            item => item?.url === 'http://enliv.com/settings/data'
          )?.valueString;
          reduxDispatch(set_current_user_setting({
            resource: { ...rawData },
            display: JSON?.parse(displaySetting),
          }))
        } else {
          const responseSetting = await createUserSetting(PersonID);
          reduxDispatch(set_current_user_setting({
            resource: { ...responseSetting?.data },
            display: JSON?.parse(
              responseSetting?.data?.extension?.[0]?.valueString
            ),
          }))
        }
      }
      setIsUserDataLoaded(true);
    } catch (e) {
      console.error(e);
    } finally {
      reduxDispatch(full_page_loader(false));
    }
  };

  const refreshUserData = async (firebaseUser, isFirebaseLoaded) => {
    if (isFirebaseLoaded) {
      reduxDispatch(full_page_loader(true));
      if (firebaseUser) {
        await getLoggedInPersonData(firebaseUser?.uid);
        if (currentLocation === '/login') {
          navigate(`/home/dashboard`, { replace: true });
        }
      } else {
        reduxDispatch(change_login(constants?.USER_LOGOUT))
        reduxDispatch(reset_state())
        navigate(`/login`, { replace: true });
        setIsUserDataLoaded(true);
      }
    }
  };

  return (
    <>
      <UnauthorizedAccess open={open} setOpen={setOpen} />
      {isFirebaseLoaded && isUserDataLoaded && <>
        {/* <JoyrideImplementation /> */}
        <Routes />
      </> || <FallBackLoader />}
    </>
  )
}

export default App;
